import type { ResultOf } from 'gql.tada';
import { graphql } from '@/lib/graphql';

export const PersonasListSubscription = graphql(`
  subscription PersonasList($organizationId: Uuid!) {
    personas(
      where: { organizationId: { _eq: $organizationId }, deletedAt: { _isNull: true } }
      orderBy: { createdAt: ASC }
    ) {
      id
      name
      description
      outputHandles
      personaDocumentsAggregate {
        aggregate {
          count
        }
      }
    }
  }
`);

export const PersonaSubscription = graphql(`
  subscription Persona($personaId: Uuid!) {
    personasByPk(id: $personaId) {
      id
      deletedAt
      name
      description
      instructions
      greeting
      modelId
      maxTurns
      outputHandles
    }
  }
`);

export const PersonaDocumentsSubscription = graphql(`
  subscription PersonaDocuments($personaId: Uuid!) {
    personaDocuments(where: { personaId: { _eq: $personaId } }, orderBy: { createdAt: ASC }) {
      id
      name
      type
      status
      sourceUrl
      error
    }
  }
`);

export const ActiveAiModelsSubscription = graphql(`
  subscription ActiveAiModels {
    aiModels(where: { isActive: { _eq: true } }, orderBy: { name: ASC }) {
      id
      name
      isDefault
    }
  }
`);

export const CreatePersonaMutation = graphql(`
  mutation CreatePersona($object: PersonasInsertInput!) {
    insertPersonasOne(object: $object) {
      id
    }
  }
`);

export const UpdatePersonaMutation = graphql(`
  mutation UpdatePersona($personaId: Uuid!, $set: PersonasSetInput!) {
    updatePersonasByPk(pkColumns: { id: $personaId }, _set: $set) {
      id
    }
  }
`);

export type PersonaDetail = NonNullable<ResultOf<typeof PersonaSubscription>['personasByPk']>;
